import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Calendar = ({ className }) => {
  return (
    <svg
      viewBox='0 0 349 368'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classnames('icon', 'icon-calendar', { [className]: className })}
    >
      <path d='M106.346 0H86.7188V58.7938H106.346V0Z' fill='#303347' />
      <path d='M262.846 0H243.219V58.7938H262.846V0Z' fill='#303347' />
      <path
        d='M282.472 19.5938V39.1869H329.373V84.9137H19.6273V39.2013H67.0755V19.5938H0V368.001H349V19.5938H282.472ZM329.373 348.393H19.6273V104.521H329.373V348.407V348.393Z'
        fill='#303347'
      />
      <path d='M223.591 19.5938H125.973V39.1869H223.591V19.5938Z' fill='#303347' />
      <path d='M98.7141 131.199H46.3555V183.467H98.7141V131.199Z' fill='#252737' />
      <path d='M166.695 131.199H114.336V183.467H166.695V131.199Z' fill='#252737' />
      <path d='M234.679 131.199H182.32V183.467H234.679V131.199Z' fill='#252737' />
      <path d='M98.7141 269.461H46.3555V321.728H98.7141V269.461Z' fill='#252737' />
      <path d='M166.695 269.461H114.336V321.728H166.695V269.461Z' fill='#252737' />
      <path d='M234.679 269.461H182.32V321.728H234.679V269.461Z' fill='#252737' />
      <path d='M302.659 131.199H250.301V183.467H302.659V131.199Z' fill='#252737' />
      <path d='M302.659 269.461H250.301V321.728H302.659V269.461Z' fill='#252737' />
      <path d='M98.7141 200.328H46.3555V252.596H98.7141V200.328Z' fill='#252737' />
      <path d='M166.695 200.328H114.336V252.596H166.695V200.328Z' fill='#252737' />
      <path d='M234.679 200.328H182.32V252.596H234.679V200.328Z' fill='#303347' />
      <path d='M302.659 200.328H250.301V252.596H302.659V200.328Z' fill='#252737' />
    </svg>
  );
};

Calendar.propTypes = {
  className: PropTypes.string,
};

export default Calendar;
